import { get } from "@ember/object"
import Patch from "@shared/models/patch-updater"
import defaultLessonActivity from "./default-lesson-activity"
import defaultLessonContext from "./default-lesson-context"
import defaultLessonModels from "./default-lesson-models"
import { map } from "lodash-es"

export const LESSON_STANDARDS_PASTE = {
  name: "LESSON_STANDARDS_PASTE",

  params: {
    cardStackId: "string",
    standards: { type: "array", items: { type: "object" } },
  },

  patches(payload) {
    let patch = Patch.create("card-stack", payload.cardStackId, "attributes.cards", {
      id: payload.cardId,
    }).addToSet("embedded", "attributes.standards", ["$each", payload.standards]).patch

    return [patch]
  },

  undoPatches(payload) {
    let patch = Patch.create("card-stack", payload.cardStackId, "attributes.cards", {
      id: payload.cardId,
    }).pullAll(
      "embedded",
      "attributes.standards",
      JSON.parse(JSON.stringify(payload.standards))
    ).patch

    return [patch]
  },

  narrative(payload, findFn, userId) {
    let models = defaultLessonModels(payload, findFn, userId)
    let context = defaultLessonContext(payload, models)
    let standards = map(payload.standards, (standard) => {
      return standard.code
    })
    let standardSets = map(payload.standards, (standard) => {
      return `${standard.jurisdiction} - ${standard.grades} - ${standard.subject}`
    })
    context.editType = "paste"
    context.standards = standards
    context.standardSets = standardSets

    let count = get(payload, "standards.length")
    let noun = count === 1 ? "standard" : "standards"
    let description = `Pasted ${count} ${noun}`
    return {
      title: "Pasted Standards",
      titleForAnalytics: "Standards - paste",
      context: context,
      activity: defaultLessonActivity(payload, models),
      description: description,
    }
  },
}
export default LESSON_STANDARDS_PASTE
